import { SliderHTMLElement } from '../../../../common/slider/slider';

const ATTRIBUTES = ['data-items-count', 'data-variant', 'data-edit-mode'];

export class WallSliderWithTitleHTMLElement extends SliderHTMLElement {
    constructor() {
        super({
            containerSelector: '.wall-slider-with-title__container--items',
            itemsContainerSelector: '.wall-slider-with-title__items',
            itemSelector: '.wall-slider-with-title__item',
            nextNavSelector: '.wall-slider-with-title__next',
            prevNavSelector: '.wall-slider-with-title__prev',
            resizeListener: false
        });
    }

    static get observedAttributes(): string[] {
        return ATTRIBUTES;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRIBUTES.includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        super.attributeChangedCallback(name, oldValue, newValue);

        setTimeout(() => {
            switch (name) {
                case 'data-items-count':
                    this.itemsTotal = Number.parseInt(newValue);
                    if (newValue > oldValue) {
                        this.reset();
                    } else {
                        this.reset(this.startingSlideIndex);
                    }
                    break;
                case 'data-variant':
                    this.sliderType = `WallSliderWithTitle - ${newValue}`
                    if (oldValue !== null) {
                        this.reset(this.startingSlideIndex);
                    }
                    break;
                default:
                    break;
            }
        })
    }
}
